import { PARTY_LABEL, type Requirement } from '../audit/requirements';
import { plural } from './plural';

/**
 * What "Long distance" means for a store (DM + exec reflect 2026-10-25: the
 * tag had no meaning on screen): each template clock whose window it
 * lengthens, e.g. "DM Visit: DM every 30 days instead of 15". The live
 * templates that apply to the store are passed in; null when none changes.
 */
export function longDistanceWindows(templates: readonly { name: string; requirements: readonly Requirement[] }[]): string | null {
  const parts = templates.flatMap((t) =>
    t.requirements
      .filter((r) => r.longDistanceDays && r.longDistanceDays !== r.frequencyDays)
      .map((r) => `${t.name}: ${PARTY_LABEL[r.party]} every ${plural(r.longDistanceDays ?? 0, 'day')} instead of ${r.frequencyDays}`),
  );
  return parts.length > 0 ? parts.join('; ') : null;
}
